import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { deleteMaterialSeries } from "../api/deleteMaterialSeries";

export const useDeleteMaterialSeries = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteMaterialSeries(id),
    onSuccess: () => {
      toast.success("Deleted successfully.");
      queryClient.invalidateQueries({ queryKey: ["allSeries"] });
    },
    onError: () => {
      toast.error("Failed to delete. Please try again.");
    },
  });
};

